import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { DocNode } from '@atlaskit/adf-schema';
import type { JSONNode } from '@atlaskit/editor-json-transformer';

import type { AiStreamingOrchestratorPlugin } from '@atlassian/editor-plugin-ai-streaming-orchestrator';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

export const getDocument = async (
	editorApi: PublicPluginAPI<[AIPlugin, AiStreamingOrchestratorPlugin]>,
): Promise<DocNode | null> => {
	return new Promise((resolve) => {
		try {
			editorApi.core.actions.requestDocument(
				(doc: any) => {
					resolve(doc as DocNode);
				},
				{ alwaysFire: true },
			);
		} catch {
			resolve(null);
		}
	});
};

export function isEmptyDocument(doc: DocNode): boolean {
	if (!doc.content || doc.content.length === 0) {
		return true;
	}

	if (doc.content.length === 1) {
		const node = doc.content[0] as any;
		if (node.type === 'paragraph') {
			if (!node.content || node.content.length === 0) {
				return true;
			}

			return isOnlyWhitespaceContent(node.content);
		}

		if (node.type === 'heading') {
			if (!node.content || node.content.length === 0) {
				return true;
			}

			return isOnlyWhitespaceContent(node.content);
		}
	}

	return false;
}

function isOnlyWhitespaceContent(content: JSONNode[]): boolean {
	for (const node of content) {
		if (node.type === 'text') {
			if (node.text && node.text.trim().length > 0) {
				return false;
			}
		} else {
			return false;
		}
	}
	return true;
}

export function chunkSubstr(str: string, size: number) {
	const numChunks = Math.ceil(str.length / size);
	const chunks = new Array(numChunks);

	for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
		chunks[i] = str.substring(o, o + size);
	}

	return chunks;
}
